import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, VhvVorbelegungdaten } from '@ps20-frontend/frontend-models';
import {
  Wertsachensumme,
  WertsachenSummeChangedAction,
  WertsachensummenChangedAction,
} from '../model/wertsachensummen.model';
import { VhvActions } from '../vhvActions';
import { IAppState } from '../appState';

export const wertsachensummenReducer = function (
  sectionState: Wertsachensumme[] = null,
  action: AnyAction,
  appState: IAppState,
): Wertsachensumme[] {
  switch (action.type) {
    case VhvActions.WERTSACHENSUMMEN_CHANGED:
    case VhvActions.WERTSACHENSUMMEN_CHANGED_AFTER_VORBELEGUNG: {
      const changeAction: WertsachensummenChangedAction = action;
      const { wertsachensummen } = changeAction.payload;
      return wertsachensummen;
    }
    case VhvActions.WERTSACHENSUMME_CHANGED: {
      const changeAction: WertsachenSummeChangedAction = action;
      const changedWertsachensumme = changeAction.payload;
      return sectionState.map(wertsachensumme => {
        if (wertsachensumme.produktline === changedWertsachensumme.produktline) {
          return { ...wertsachensumme, ...changedWertsachensumme };
        }
        return wertsachensumme;
      });
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VhvVorbelegungdaten = action.payload;
      if (
        actionPayload.forApp === App.VHV &&
        actionPayload.angebotsId === appState.angebotsId &&
        actionPayload.wertsachensumme
      ) {
        return [
          {
            produktline: actionPayload.produktlinienname,
            summe: actionPayload.wertsachensumme,
          } as Wertsachensumme,
        ];
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
